export enum DeleteModalVariantsEnum {
  WithEntities = 0,
  WithoutEntities,
}
